import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Amount } from '../../../templates/Amount';

export const PeriodicGetBackTermAmount: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/PeriodicGetBackTermAmount.${label}.${locale}.json`)}>
      <PeriodicGetBackTermAmountComponent />
    </I18nProvider>
  );
};

export const PeriodicGetBackTermAmountComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.PeriodicGetBackTermAmount'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Amount
      title={t('periodicGetBackTermAmount.title')}
      content={t('periodicGetBackTermAmount.content')}
      buttonHref={t('periodicGetBackTermAmount.buttonLink.href')}
      buttonText={t('periodicGetBackTermAmount.buttonLink.text')}
      label={t('periodicGetBackTermAmount.singleAmountLabel')}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('periodicGetBackTermAmount.imageSrc')}`,
        },
      }}
    />
  );
};
